import { render, staticRenderFns } from "./FeaturesLabels.vue?vue&type=template&id=49d691fc&scoped=true"
import script from "./FeaturesLabels.vue?vue&type=script&lang=js"
export * from "./FeaturesLabels.vue?vue&type=script&lang=js"
import style0 from "./FeaturesLabels.vue?vue&type=style&index=0&id=49d691fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d691fc",
  null
  
)

export default component.exports